import React, { createContext, useContext } from 'react';
import { Logger } from './Logger';

const LoggerContext = createContext<Logger | null>(null);

export const LoggerProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const logger = new Logger();
  return (
    <LoggerContext.Provider value={logger}>{children}</LoggerContext.Provider>
  );
};

export const useLogger = (): Logger => {
  const context = useContext(LoggerContext);
  if (context === null) {
    throw new Error('useLogger must be used within a LoggerProvider');
  }
  return context;
};
